import { rolesStore } from 'views/Roles';

/**
 * Verifica se o usuário possui pelo menos uma das roles especificadas.
 *
 * @param {string[]} requiredRoles - Array com as roles necessárias para verificação (case-insensitive).
 * @returns {boolean} - Retorna true se o usuário tiver pelo menos uma das roles, false caso contrário.
 *
 * @example
 * // Verifica se o usuário tem permissão para editar contatos
 * verifyRoles(['CRM_CONTACTS_EDIT'])
 *
 * @example
 * // Verifica se o usuário tem pelo menos uma das permissões
 * verifyRoles(['CRM_CONTACTS_EDIT', 'CRM_CONTACTS_VIEW'])
 */
export const verifyRoles = (requiredRoles) => {
  const userRoles = rolesStore.getRoles();

  if (!userRoles) {
    console.warn('User roles not loaded yet.');
    return false;
  }

  if (!requiredRoles || requiredRoles.length === 0) {
    console.warn('No roles specified for verification.');
    return false;
  }

  const userRolesSet = new Set(
    userRoles.map((role) => role.role.toUpperCase())
  );

  return requiredRoles.some((role) => userRolesSet.has(role.toUpperCase()));
};
